import React from 'react';

import moment from 'moment';
import {isAllShareAllPool } from '../../utils/commonUtil';
export function disabledValidator(accData) {
  let isAllShareAllPoolStatus = isAllShareAllPool();
  return accData.availableBalance === 0
    ? true
    : false || isAllShareAllPoolStatus
    ? true
    : false || accData.roleAccess === 'Read Only'
    ? true
    : false ;
}

export function disabledText(accData) {
  let isAllShareAllPoolStatus = isAllShareAllPool();
  return accData.availableBalance === 0 && accData.roleAccess === 'Read Only'
    ? 'Our records show that you do not have the authority to continue with this workflow online. To change authorities, account advisors must submit a change. For help please call a Program Representative at 888-383-4483.'
    : '' || accData.availableBalance === 0
    ? 'This account has $0.00 balance. Exchange transaction cannot continue.'
    : '' || isAllShareAllPoolStatus
    ? 'A grant has been recommended to close the account. Additional grant transactions cannot be submitted.'
    : '' || accData.roleAccess === 'Read Only'
    ? 'You are unable to recommend exchanges on this account. If you believe this is an error, please contact us at 888-383-4483.'
    : '' ;
}

export function amountFormatter(data) {
  return `$${Number(data).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;
}

export function dateFormatter(milliseconds) {
  if (!milliseconds) return <span>&mdash;</span>;
  return moment(milliseconds).format('L');
}
